import React, { createContext, useContext, useState } from 'react';

const NavbarContext = createContext();

export const useNavbar = () => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbar must be used within a NavbarProvider');
  }
  return context;
};

export const NavbarProvider = ({ children }) => {
  const [isVisible, setIsVisible] = useState(true);

  const hideNavbar = () => setIsVisible(false);
  const showNavbar = () => setIsVisible(true);

  return (
    <NavbarContext.Provider value={{ isVisible, hideNavbar, showNavbar }}>
      {children}
    </NavbarContext.Provider>
  );
};
